// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";
import { DealerModel, PaginationModel } from "@insite/client-framework/Types/ApiModels";

export interface IEventModel {
    startTime: string;
    endTime: string;
    eventDate: string;
    publishOn: string;
    location: string[];
    title: string;
    url: string;
    imagePublicId: string;
    imageAltText: string;
    summary: string;
    city: string;
    state: string;
}

export interface IEventCollectionModel {
    pagination: PaginationModel;
    events: IEventModel[];
}

export interface IEventListResponse {
    statusCode: number;
    result: IEventCollectionModel;
}

export interface IEventDetailsModel {
    type: string;
    courseCode: string;
    cost: string;
    ceuEligible: boolean;
    locationData: DealerModel;
    startTime: string;
    endTime: string;
    eventDate: string;
    publishOn?: string;
    location?: string[];
    title?: string;
    url?: string;
    summary?: string;
    subTitle?: string;
    imagePublicId?: string;
}

export interface IEventListParams extends ApiParameter {
    eventType?: string;
    location?: string;
    category?: string;
    brand?: string;
    pageTargets?: string;
    isFeatured?: boolean;
    sortAscending?: boolean;
    onlyUpcomingEvents?: boolean;
    parentId?: string;
    pageSize?: number;
    page?: number;
}

const baseServiceUri = "/api/vmi/allEvents";

export const getEventList = async (params: IEventListParams): Promise<IEventListResponse> => {
    const result: IEventListResponse = await get<IEventListResponse>(baseServiceUri + "/getEvents", params);
    return result;
};

export const getEvent = async ({ pageId }: { pageId: string }): Promise<IEventDetailsModel> => {
    const result: IEventDetailsModel = await get<IEventDetailsModel>(baseServiceUri + "/event/" + pageId);
    return result;
};

export const getEventLocations = async (): Promise<string[]> => {
    const result: string[] = await get<string[]>(baseServiceUri + "/eventLocations");
    return result;
};

export const getEventTypes = async (location: string = ""): Promise<string[]> => {
    const result: string[] = await get<string[]>(baseServiceUri + "/eventTypes/" + location);
    return result;
};
